import React, {useEffect, useState, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import InfiniteScroll from "react-infinite-scroll-component";

import {getWorkspace} from '../../../../actions/my-topic';
import useDisableScrollDocument from '../../../../useHook/useDisableScrollDocument';

import styles from './modal.module.css';

function TopicCopyWorkspace(props) {
    const dispatch = useDispatch();
    useDisableScrollDocument();

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [hasNext, setHasNext] = useState(false);
    const [workspaces, setWorkspaces] = useState([]);
    const [selectedWorkspace, setSelectedWorkspace] = useState(null);

    useEffect(() => {
        fetch(currentPage, false);
    }, []);

    const fetch = useCallback(async (currentPage, more) => {
        if(!more) {
            setLoading(true);
        }
        const response = await dispatch(getWorkspace(currentPage));
        if(!more) {
            setLoading(false);
            setWorkspaces(response.data);
        }else {
            setWorkspaces([...workspaces, ...response.data]);
        }
        setLastPage(response.meta.last_page);
        setCurrentPage(response.meta.current_page);
        setHasNext(currentPage < response.meta.last_page);
    }, [workspaces]);

    const onLoadMore = useCallback(async () => {
        if(currentPage > lastPage) return;
        const page = currentPage + 1;
        fetch(page, true);
    }, [currentPage, lastPage, workspaces]);

    const onSelectWorkspace = useCallback((workspace) => {
        setSelectedWorkspace(workspace)
    }, []);

    return <div className={styles.modalWrapper}>
        <div className={styles.modalContent} style={{ padding: '0'}}>
            <h4 className={styles.modalTitle} style={{ padding: '24px', borderBottom: '1px solid #d7dadc'}}>
                ワークスペースにコピー
            </h4>
            <div className={styles.copyTopicWorkspaceWrapper}>
                <InfiniteScroll
                    dataLength={workspaces.length}
                    next={onLoadMore}
                    hasMore={hasNext}
                    height={320}
                    loader={null}
                >
                    {workspaces.map((workspace) => <div  onClick={() => onSelectWorkspace(workspace)} className={classNames(styles.copyTopicItem, selectedWorkspace &&  workspace.id === selectedWorkspace.id && styles.copyTopicItemActive)} key={workspace.id}>
                        {workspace.title}
                    </div>)}
                </InfiniteScroll>

                {loading && <div className={styles.topicLoading}>
                    <FontAwesomeIcon icon={faSpinner} pulse color={'#3D3DF2'} size="lg"/>
                </div>
                }
            </div>
            <div className={styles.footerTopic} style={{
                borderTop: '1px solid #d7dadc',
                marginTop: 0,
            }}>
                <button className={styles.buttonModal} onClick={props.onClose}>キャンセル</button>
                <button className={styles.buttonModal} onClick={() => {
                    if(!selectedWorkspace) return;
                    props.onSave(selectedWorkspace);
                }}>決定</button>
            </div>
        </div>
    </div>
}

export default TopicCopyWorkspace;